import {
  FetchPlugin,
  getAlfMockAdapter,
  MockInterceptFetch,
  MockInterceptRequest,
  RequestPlugin,
} from '@ama-sdk/core';
import {
  Platform,
} from '@angular/cdk/platform';
import {
  EventTrackService,
} from '@o3r/analytics';
import {
  ApiManager,
} from '@o3r/apis-manager';
import {
  RequestParametersService,
} from '@o3r/dynamic-content';
import {
  LoggerService,
} from '@o3r/logger';
import {
  AppBootstrapConfig,
  BotProtectionFactory,
  ExtraPluginsByAPI,
} from '@refx/shared-common';
import {
  AmadeusGatewayTokenService,
  AppInitializationService,
  createApiManagerFactory,
} from '@refx/shared-services';
import {
  isAlfMockScenario,
  mockAdapter,
} from './mocks/index';

/**
 * Factory that creates the API manager configuration for the application
 *
 * @param config
 * @param botProtectionFactory
 * @param eventTrackService
 * @param requestParametersService
 * @param appInitializationService
 * @param gatewayTokenService
 * @param platform
 * @param extraPluginsByAPI
 * @param loggerService
 */
export function createServicingApisFactory(
  config: AppBootstrapConfig,
  botProtectionFactory: BotProtectionFactory,
  eventTrackService: EventTrackService,
  requestParametersService: RequestParametersService,
  appInitializationService: AppInitializationService,
  gatewayTokenService: AmadeusGatewayTokenService,
  platform: Platform,
  extraPluginsByAPI: ExtraPluginsByAPI,
  loggerService?: LoggerService
): ApiManager {
  const requestPlugins: RequestPlugin[] = [];
  const fetchPlugins: FetchPlugin[] = [];
  const useMocks = appInitializationService.shouldUseMocks();

  if (useMocks) {
    /** Request interceptor that only kicks in the query parameter useMocks is defined */
    const scenario = appInitializationService.getScenario();
    const adapter = isAlfMockScenario(scenario)
      ? getAlfMockAdapter(
        scenario!,
        () => import('@dapi/sdk/spec').then(({OPERATION_ADAPTER}) => OPERATION_ADAPTER)
      ) : mockAdapter;
    requestPlugins.push(new MockInterceptRequest({
      adapter: adapter
    }));
    fetchPlugins.push(new MockInterceptFetch({
      adapter: adapter
    }));
  }

  return createApiManagerFactory(
    config,
    botProtectionFactory,
    eventTrackService,
    appInitializationService,
    platform,
    fetchPlugins,
    requestPlugins,
    [],
    extraPluginsByAPI,
    gatewayTokenService.getOfficeIdSupplier(),
    undefined,
    undefined,
    undefined,
    loggerService
  );
}
